const TextCollapsed = () => {
  const textCollapsedBlocks = [...document.querySelectorAll(".text-collapsed")];

  const getTextWrapperMaxHeight = (element) => {
    const hasImage = element.classList.contains("with-image");
    const product = element.classList.contains("product");

    let textWrapperMaxHeight;

    const maxHeightValues = {
      standart: {
        desktop: "72px",
        tablet: "72px",
        mobile: "60px",
      },
      image: {
        desktop: "160px",
        tablet: "128px",
        mobile: "120px",
      },
      product: {
        desktop: "96px",
        tablet: "96px",
        mobile: "80px",
      },
    };

    if (hasImage) {
      if (window.innerWidth < 768) {
        textWrapperMaxHeight = maxHeightValues.image.mobile;
      } else if (window.innerWidth >= 768 && window.innerWidth < 1024) {
        textWrapperMaxHeight = maxHeightValues.image.tablet;
      } else if (window.innerWidth >= 1024) {
        textWrapperMaxHeight = maxHeightValues.image.desktop;
      }
    } else if (product) {
      if (window.innerWidth < 768) {
        textWrapperMaxHeight = maxHeightValues.product.mobile;
      } else if (window.innerWidth >= 768 && window.innerWidth < 1024) {
        textWrapperMaxHeight = maxHeightValues.product.tablet;
      } else if (window.innerWidth >= 1024) {
        textWrapperMaxHeight = maxHeightValues.product.desktop;
      }
    } else {
      if (window.innerWidth < 768) {
        textWrapperMaxHeight = maxHeightValues.standart.mobile;
      } else if (window.innerWidth >= 768 && window.innerWidth < 1024) {
        textWrapperMaxHeight = maxHeightValues.standart.tablet;
      } else if (window.innerWidth >= 1024) {
        textWrapperMaxHeight = maxHeightValues.standart.desktop;
      }
    }

    return textWrapperMaxHeight;
  };

  if (textCollapsedBlocks.length > 0) {
    textCollapsedBlocks.forEach((textCollapsedBlock) => {
      const textWrapper = textCollapsedBlock.querySelector(".text-collapsed__text-wrapper");

      const paragraphs = [...textCollapsedBlock.querySelectorAll(".text-collapsed__text-wrapper p")];
      const lastIndex = paragraphs.length - 1;
      const lastParagraph = paragraphs[lastIndex];

      const hideBtnHtml = `<button type="button" class="text-collapsed__hide-btn">hide</button>`;

      const expandBtn = textWrapper.querySelector(".text-collapsed__expand-btn");

      const textWrapperMaxHeight = getTextWrapperMaxHeight(textCollapsedBlock);

      if (expandBtn) {
        expandBtn.addEventListener("click", () => {
          textWrapper.classList.add("expanded");
          textWrapper.style.maxHeight = textWrapper.scrollHeight + "px";
          lastParagraph.insertAdjacentHTML('beforeend', hideBtnHtml);
          const hideBtn = textWrapper.querySelector(".text-collapsed__hide-btn");

          if (hideBtn) {
            hideBtn.addEventListener("click", () => {
              textWrapper.classList.remove("expanded");
              textWrapper.style.maxHeight = textWrapperMaxHeight;
              hideBtn.remove();
            });
          }
        });
      }
    });
  }
}

export default TextCollapsed;
